import { useCallback, useContext, useMemo, useState } from 'react';
import { Lesson, LessonService } from '../service/lesson-service';
import { useMount } from './useUnmount';
import useLessonContext from './useLessonContext';
import useLanguageSelector from './useLanguageSelector';
import useErrorStateContext from './useErrorStateContext';

const useLesson = (companyId: string, roomId: string) => {
  const LANG = useLanguageSelector();
  const [lessonInfo, setLessonInfo] = useState<Lesson | undefined>(undefined);
  const lessonService = useMemo(() => new LessonService(), []);
  const { updateLessonInfo } = useLessonContext();
  const errorCtx = useErrorStateContext();

  const fetchLessonInfo = useCallback(async () => {
    const lesson = await lessonService.fetchLessonInfo(companyId, roomId);
    if (!lesson) {
      errorCtx.setErrorState({
        error: new Error(),
        message: LANG.KT_9000_03
      });
      return;
    }
    if (lessonInfo) {
      setLessonInfo({
        ...lessonInfo,
        ...lesson
      });
    } else {
      setLessonInfo({
        ...lesson
      });
    }
    updateLessonInfo(lesson);
  }, [companyId, roomId, lessonService, LANG, errorCtx, updateLessonInfo]);

  useMount(() => {
    fetchLessonInfo();
  });
  return { lessonInfo };
};
export default useLesson;

// export default function useLesson({ companyId, roomId }: { companyId: string; roomId: string }) {
//   const [lesson, setLesson] = useState<Lesson | null>(null);

//   useEffect(() => {
//     if (!companyId || !roomId) {
//       return;
//     }
//     const request = async () => {
//       const response = await requestServerApi<any>(() =>
//         serverApi.organizationsControllerGetLessonByRoomId(companyId, roomId)
//       );

//       if (response.data.data && Object.keys(response.data.data[0]).length > 0) {
//         setLesson(response.data.data[0]);
//       }
//     };

//     request();
//   }, [companyId, roomId]);

//   return { lesson };
// }
